import React from 'react';
import SidebarUnitDesktop
    from "components/sidebar/components/SidebarUnitDesktop";
import {DashboardIcon} from "assets/icons";

const DashboardLink = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Tableau de Bord"} 
            routeSidebar={"/dashboard"}
            icon={DashboardIcon}
            text={"Tableau de bord"}
            exactMatch={true}
        />
    );
};

export default DashboardLink;